module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unbindBody"
  }, [_c('div', {
    staticClass: "icon_avator"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('router-link', {
    staticClass: "mot-btn wid",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("立即绑定 "), _c('span', {
    staticClass: "tc-btnlist-gt"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "txt"
  }, [_c('p', [_vm._v("为享受阿贝云更多的贴心服务")]), _vm._v(" "), _c('p', [_vm._v("请先绑定阿贝云帐号")]), _vm._v(" "), _c('p', [_vm._v("绑定后可在PC端扫码登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e33fa52c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unbind.vue
// module id = zYg9
// module chunks = 1